"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const accountCardStyles = ({ spacing, palette, shadows, shape }) => ({
    rootContainer: {
        backgroundColor: palette.background.paper,
        marginBottom: spacing(4),
        padding: spacing(2),
        borderTop: 'none',
        minWidth: '100%',
        borderRadius: 20,
        boxShadow: shadows[2],
        overflow: 'hidden',
        '&:hover': {
            boxShadow: shadows[8],
        },
    },
    headerTitleContainer: {
        display: 'flex',
        alignItems: 'center',
        flexGrow: 1,
    },
    headerContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        position: 'relative',
        alignItems: 'center',
    },
    columnHeadersContainer: {
        paddingLeft: spacing(3),
        paddingRight: spacing(5),
        textAlign: 'center',
    },
    loginMenuIcon: {
        color: palette.text.primary,
    },
    contentContainer: {},
    errorContainer: {
        backgroundColor: palette.background.hintSubtle,
        borderRadius: shape.borderRadius * 2,
        display: 'flex',
        margin: `${spacing(4)} ${spacing(1)} 0`,
        padding: spacing(2),
    },
    errorTextContainer: {
        flex: 1,
        marginRight: spacing(2),
    },
    errorSpinner: {
        margin: spacing(0, 4.5),
        alignSelf: 'center',
    },
    flexOne: {
        flex: 1,
    },
    dialogContent: {
        display: 'flex',
        alignItems: 'center',
        paddingTop: `${spacing(3)} !important`,
    },
    logo: {
        maxHeight: 50,
        maxWidth: 80,
        height: 'auto',
        width: 'auto',
        verticalAlign: 'sub',
        marginRight: spacing(1.25),
        backgroundColor: palette.background.paper,
        borderRadius: shape.borderRadius,
    },
    plaidLogo: {
        height: spacing(7),
        background: 'none',
        borderRadius: '50%',
        boxShadow: `0px 0px 1px 1px ${palette.background.paper}`,
    },
    errorActionButton: {
        alignSelf: 'center',
        marginLeft: spacing(1 / 2),
    },
});
exports.default = accountCardStyles;
